import { createFileRoute } from '@tanstack/react-router';

import { SupplyDomainsPage } from '../features/campaigns/supply/SupplyDomainsPage';
import { supplyRouteSearchSchema } from '../features/campaigns/supply/supplyRouteSearch';

export const Route = createFileRoute('/campaigns/supply/domains')({
  validateSearch: supplyRouteSearchSchema,
  component: SupplyDomainsPage,
});
